import React from "react";
import s from "./Footer.module.scss";

const Footer = () => {
  return (
    <div className={s.footer}>
      <span className={s.footerLabel}>
        2026 &copy; Crystal Clear Environmental
      </span>
    </div>
  );
};

export default Footer;
